import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { ArrowRight } from "lucide-react";

const FORM_URL = "https://form.jotform.com/261474680292058";

export const CTASection = ({ variant = "top" }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-60px" });

  return (
    <section
      data-testid={`cta-section-${variant}`}
      ref={ref}
      className={`relative py-20 md:py-28 px-6 md:px-12 overflow-hidden ${
        variant === "top" ? "bg-[#121212]" : "bg-[#121212] border-t border-[#2A2A2A]/30"
      }`}
    >
      {/* Ambient glow behind button */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <div className="w-[500px] h-[500px] bg-[#E8891C]/[0.04] rounded-full blur-[120px]" />
      </div>

      <div className="relative z-10 max-w-3xl mx-auto text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          <h2
            className="font-serif text-3xl md:text-4xl lg:text-5xl text-[#F5F5F0] tracking-tight mb-6"
            data-testid={`cta-title-${variant}`}
          >
            Prêt à démarrer votre <span className="italic text-[#E8891C]">projet?</span>
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.7, delay: 0.2, ease: "easeOut" }}
        >
          <p className="font-sans text-base md:text-lg text-[#A1A1AA] leading-relaxed max-w-xl mx-auto mb-10">
            Remplissez notre formulaire de demande de soumission gratuite en quelques minutes. Nous vous répondrons rapidement avec une estimation personnalisée.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.4, ease: "easeOut" }}
          className="relative inline-block"
        >
          {/* Pulsing glow ring */}
          <span className="absolute inset-0 -m-1 rounded-sm bg-[#E8891C]/20 animate-[pulse_2.5s_ease-in-out_infinite]" />

          <a
            href={FORM_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`cta-button-${variant}`}
            className="group relative inline-flex items-center gap-3 bg-[#E8891C] text-[#0A0A0A] px-10 py-5 font-sans text-sm font-bold uppercase tracking-[0.2em] hover:bg-[#F5A642] transition-colors duration-500"
          >
            Demander une soumission gratuite
            <ArrowRight
              size={18}
              className="transition-transform duration-300 group-hover:translate-x-1"
              strokeWidth={2.5}
            />
          </a>
        </motion.div>
      </div>
    </section>
  );
};
